import moment from "moment";

export default {
  methods: {
    buildRangeOfDates(rangeOfDates) {
      let _rangeOfDates = { ...rangeOfDates };
      _rangeOfDates.start = moment(_rangeOfDates.start)
        .startOf("day")
        .toDate();
      _rangeOfDates.end = moment(_rangeOfDates.end)
        .endOf("day")
        .toDate();
      return _rangeOfDates;
    },
    buildRangeOfDatesLastYear(rangeOfDates) {
      let _rangeOfDatesLastYear = { ...rangeOfDates };
      _rangeOfDatesLastYear.start = moment(_rangeOfDatesLastYear.start)
        .startOf("day")
        .subtract(1, "year")
        .toDate();
      _rangeOfDatesLastYear.end = moment(_rangeOfDatesLastYear.end)
        .endOf("day")
        .subtract(1, "year")
        .toDate();

      return _rangeOfDatesLastYear;
    }
  }
};
